// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__232kZ","footer":"styles_footer__2fShZ"};